import {
	channelNamesMap,
	TRANSACTION_CHANNEL as transactionChannel,
} from "@/services/notification/utils/channel-names";

export const subscribeToTransactionEvent = ({subscribeToChannel}) => {
  subscribeToChannel({
		channel: transactionChannel,
		eventNames: channelNamesMap.notificationEvents,
	});
}

export const unsubscribeToTransactionEvent = ({unSubscribeToChannel}) => {
  unSubscribeToChannel({
		channel: transactionChannel,
		eventNames: channelNamesMap.notificationEvents,
	});
}
